var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoUl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.63,11.94H17.66c-1.11,0-2-.89-2-2s.89-2,2-2h21.97c1.11,0,2,.89,2,2s-.89,2-2,2Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.37,12.96c-1.45,0-2.72-1.05-2.96-2.52-.26-1.64,.85-3.18,2.48-3.44l.3-.05c1.64-.28,3.18,.85,3.44,2.48,.26,1.64-.85,3.18-2.48,3.44l-.3,.05c-.16,.03-.32,.04-.48,.04Z",
    fill: outlineColor
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.37,27.15c-1.45,0-2.72-1.05-2.96-2.52-.26-1.64,.85-3.18,2.48-3.44l.3-.05c1.64-.28,3.18,.85,3.44,2.48,.26,1.64-.85,3.18-2.48,3.44l-.3,.05c-.16,.03-.32,.04-.48,.04Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.63,26.12H17.66c-1.11,0-2-.89-2-2s.89-2,2-2h21.97c1.11,0,2,.89,2,2s-.89,2-2,2Z",
    fill: outlineColor
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.37,41.08c-1.45,0-2.72-1.05-2.96-2.52-.26-1.64,.85-3.18,2.48-3.44l.3-.05c1.64-.28,3.18,.85,3.44,2.48,.26,1.64-.85,3.18-2.48,3.44l-.3,.05c-.16,.03-.32,.04-.48,.04Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.63,40.06H17.66c-1.11,0-2-.89-2-2s.89-2,2-2h21.97c1.11,0,2,.89,2,2s-.89,2-2,2Z",
    fill: outlineColor
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUl);
export default __webpack_public_path__ + "static/media/ico-ul.2f647ecd9847845ead5a51b712d57797.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;